if (!window.Eurus.loadedScript.has('product-recommendations.js')) {
  window.Eurus.loadedScript.add('product-recommendations.js');

  const registerProductRecommendations = () => {
    Alpine.store('xProductRecommendations', {
        load(el, url) {
          fetch(url)
            .then(response => response.text())
            .then(text => {
              const html = document.createElement('div');
              html.innerHTML = text;
              const recommendations = html.querySelector('.product-recommendations');

              if (recommendations && recommendations.innerHTML.trim().length) {
                requestAnimationFrame(() => {
                  el.innerHTML = recommendations.innerHTML;
                  if (window.Eurus && window.Eurus.cardProductSliderController && typeof window.Eurus.cardProductSliderController.refresh === 'function') {
                    window.Eurus.cardProductSliderController.refresh();
                  }
                });
                if (recommendations.classList.contains('main-product')) {
                  el.className += ' mb-5 border-y border-solid accordion empty:border-b-0';
                }
              }
            })
            .catch(e => {
              console.error(e);
            });
        }
      });
  };

  if (window.Alpine && window.Alpine.version) {
    registerProductRecommendations();
  } else {
    document.addEventListener('alpine:init', registerProductRecommendations);
  }
}